import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useState } from "react";
import { addLitigationFeedback } from "services/prosecutorDecipilineService";
import { Litigation } from "types";
import { LoadingIcon } from "utils/constant";
import "../../complaintRequest/styles/AddEvidenceModal.css";

interface FeedbackModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  litigationData: Litigation;
  onRefresh: any;
}

export default function AddLitigationFeedbackModal({
  isOpen,
  setIsOpen,
  litigationData,
  onRefresh,
}: FeedbackModalProps) {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  const [formState, setFormState] = useState({
    feedback: "",
  });

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!litigationData) return;

    setLoading(true);
    // setError(null);
    // setSuccess(false);

    const data = {
      comment: formState.feedback,
      verdict: litigationData?.id || "",
    };

    try {
      await addLitigationFeedback(data);

      onRefresh();
      setIsOpen(false);
      showToast("Successfully Created", "success");
      // setSuccess(true);
      setFormState({
        feedback: "",
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast("Submission error", "error");
      // setError(
      //   err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={"Add Daily Hearing Feedback"}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Feedback
            </label>
            <textarea
              required
              rows={7}
              name="feedback"
              value={formState.feedback}
              onChange={handleChange}
              placeholder="Details here..."
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              Submitting...
            </div>
          ) : (
            "Add Feedback"
          )}
        </button>
      </form>
    </SideModal>
  );
}
